import {
  ChangeDetectionStrategy,
  Component,
  signal,
  type OnInit,
  effect,
  Input,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

type onChangeFunc = (rating: number) => void;
type onTouchedFunc = () => void;

@Component({
  selector: 'market-rating',
  standalone: true,
  imports: [],
  templateUrl: './rating.component.html',
  styleUrl: './rating.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: RatingComponent,
    },
  ],
})
export class RatingComponent implements OnInit, ControlValueAccessor {
  @Input() style: Record<string, string> = {
    width: '25px',
    height: '25px',
  };
  @Input() numberOfStars = 5;
  hoverRating = 0;
  rating = signal(0);
  disabled = signal(false);

  onChange: onChangeFunc = () => {};
  onTouched: onTouchedFunc = () => {};

  get stars() {
    return Array.from({ length: this.numberOfStars }, (_, i) => i + 1);
  }

  constructor() {
    effect(() => {
      this.onTouched();
      this.onChange(this.rating());
    });
  }

  ngOnInit(): void {}

  writeValue(obj: number): void {
    this.rating.set(obj);
  }
  registerOnChange(fn: onChangeFunc): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: onTouchedFunc): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }

  onClick(event: MouseEvent, index: number) {
    if (this.disabled()) return;
    this.rating.set(index + this.calculateStart(event));
  }
  onMouseLeave() {
    if (this.disabled()) return;
    this.hoverRating = 0;
  }
  onMouseEnter(event: MouseEvent, index: number) {
    if (this.disabled()) return;
    this.hoverRating = index + this.calculateStart(event);
  }

  calculateStart(event: MouseEvent) {
    const rect = (event.target as SVGElement).getBoundingClientRect();
    const half = (rect.right - rect.left) / 2;
    const isHalfStar = event.clientX - rect.left < half;
    return isHalfStar ? 0.5 : 1;
  }
}
